import * as React from 'react';
import { SVGProps } from 'react';

const SvgSell = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={32} height={32} rx={16} fill="#F7B0B0" />
    <path
      d="M7.821 20.122c1.719 0 2.754-.835 2.754-2.148v-.005c0-1.099-.64-1.695-2.104-1.997l-.762-.157c-.85-.175-1.235-.468-1.235-.966v-.005c0-.562.512-.947 1.338-.952.79 0 1.333.366 1.416.981l.01.059h1.205l-.005-.083c-.073-1.206-1.079-2.017-2.617-2.017-1.518 0-2.607.84-2.612 2.08v.005c0 1.05.684 1.694 2.07 1.982l.757.157c.908.19 1.275.473 1.275 1v.005c0 .606-.557 1.002-1.446 1.002-.884 0-1.504-.377-1.596-.982l-.01-.058H5.053l.005.073c.083 1.264 1.147 2.026 2.763 2.026ZM11.518 20h4.56v-1.06h-3.3v-2.006h3.12v-1.02h-3.12v-1.9h3.3v-1.06h-4.56V20Zm5.654 0h4.458v-1.06h-3.198v-5.986h-1.26V20Zm5.361 0h4.458v-1.06h-3.198v-5.986h-1.26V20Z"
      fill="#174174"
    />
  </svg>
);

export default SvgSell;
